module.exports = __webpack_public_path__ + "img/XY.af7ea023.png";